import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setSelectedCategory(value);
    if (value) {
      window.open(value, '_blank', 'noopener,nofollow');
    }
  };

  return (
    <section id="categories" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Browse Product Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Select a category below to explore thousands of curated products on the main Sugargoo Spreadsheet platform
          </p>
        </div>

        <div className="max-w-md mx-auto mb-10">
          <div className="relative">
            <select
              value={selectedCategory}
              onChange={handleDropdownChange}
              className="w-full appearance-none bg-background-100 border border-background-200/70 rounded-lg px-5 py-3.5 pr-12 text-sm text-foreground-800 font-medium cursor-pointer focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
            >
              <option value="">— Select a Category —</option>
              {categories.map((cat) => (
                <option key={cat.name} value={cat.url}>
                  {cat.name}
                </option>
              ))}
            </select>
            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
              <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-2.5 p-4 md:p-5 bg-background-100 rounded-lg border border-background-200/70 hover:border-primary-300 hover:bg-background-50 transition-all duration-300 cursor-pointer"
              data-product-shop
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-accent-200 group-hover:text-accent-700 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-foreground-950 text-center leading-tight whitespace-nowrap">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}